export const SCORE_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};

export const SCORE_TABLE_COLUMNS = [
    { id: "conversationdate", isSortable: false, label: "Conversation Date" },
    { id: "one", isSortable: false, label: "1" },
    { id: "two", isSortable: false, label: "2" },
    { id: "three", isSortable: false, label: "3" },
    { id: "four", isSortable: false, label: "4" },
    { id: "five", isSortable: false, label: "5" },
    { id: "total", isSortable: false, label: "Total" },
];

export const SCORE_TABLE_COLUMNS_KEYS = {
    CONVERSATIONDATE: "conversationdate",
    ONE: "one",
    TWO: "two",
    THREE: "three",
    FOUR: "four",
    FIVE: "five",
    TOTAL: "total",
};

export const SCORE_ERRORS = {
    FETCH_SCORE_DATA_ERROR: "Error fetching score data:",
}

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};